import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";

export interface ApiResultModel {
    uri: string;
    redirectUrl: string;
    properties: Properties;
}

export interface Properties {
    [key: string]: any;
}

const url = "api/v1/osn/getOsnOrder";

export async function osnOrderLookupService(orderNumber: string) {
    try {
        const result = await get<ApiResultModel>(`${url}?orderNumber=${orderNumber}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorMessage || error.errorJson.message || "Something went wrong!",
            };
        }
        if (error.errorMessage) {
            return {
                successful: false,
                errorMessage: error.errorMessage,
            };
        }
        throw error;
    }
}
